import { createSelector } from '@reduxjs/toolkit';
import menusSelector from './menus';

const userMenuSelector = createSelector(menusSelector, (menus) => menus.user);

export default userMenuSelector;
